'use strict';

const removeClass = (element, className) => {
  if (!element) {
    return;
  }
  if (element.classList && element.classList.remove) {
    element.classList.remove(className);
  } else {
    element.className = element.className.replace(
      new RegExp(`(?:^|\\s)${className}(?!\\S)`),
      ''
    );
  }
};

const hasClass = (element, className) => {
  if (!element) {
    return null;
  }
  return ` ${element.className} `.indexOf(` ${className} `) > -1;
};

const addClass = (element, className) => {
  if (!element || hasClass(element, className)) {
    return;
  }
  element.className += ` ${className}`;
};

const getElementsFromSelector = selector =>
  Array.prototype.slice.call(document.querySelectorAll(selector));

const getElementFromSelector = selector => document.querySelector(selector);

module.exports = {
  removeClass,
  addClass,
  hasClass,
  getElementsFromSelector,
  getElementFromSelector,
};
